export default {"src":"/_next/static/media/rappi-logo.c67556c2.svg","height":197,"width":197,"blurWidth":0,"blurHeight":0};